var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isNew)?_c('div',[_c('v-divider'),_c('v-btn',{attrs:{"text":"","color":_vm.color,"block":"","loading":_vm.loading},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.title))]),_c('v-divider')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }